// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';

import { validateChileanDocument } from './chilean-document';
import { validateChileanPhoneNumber } from './chilean-phone-number';
import { validateChileanZipcode } from './chilean-zipcode';
import { validateChileanState } from './chilean-state';
import { validateChileanCity } from './chilean-city';
import { validateChileanAddress } from './chilean-address';
import { validateChileanStreetNumber } from './chilean-street-number';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);

  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  switch (userInputName) {
    case 'chileanDocument':
      return onlyWhen('field_chilean_document') && validateChileanDocument(userInputValue);

    case 'chileanPhoneNumber':
      return onlyWhen('field_chilean_phone_number') && validateChileanPhoneNumber(userInputValue);

    case 'chileanZipcode':
      return onlyWhen('field_chilean_zipcode') && validateChileanZipcode(userInputValue);

    case 'chileanState':
      return onlyWhen('field_chilean_state') && validateChileanState(userInputValue);

    case 'chileanCity':
      return onlyWhen('field_chilean_city') && validateChileanCity(userInputValue);

    case 'chileanAddress':
      return onlyWhen('field_chilean_address') && validateChileanAddress(userInputValue);

    case 'chileanStreetNumber':
      return onlyWhen('field_chilean_street_number') && validateChileanStreetNumber(userInputValue);

    default:
      return VALID;
  }
}
